<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="品类名称">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="品类简介">
                <a-input v-model="queryParam.titleIntro" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>

            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 禁用 </a-select-option>
                    <a-select-option :value="1"> 正常 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['abm-fix:dev:add']">
            <a-icon type="plus" />新增
          </a-button>
          <a-button
type="primary"
:disabled="single"
@click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137d:0:d']">
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137r:0:r']">
            <a-icon type="delete" />删除
          </a-button>
        </template>
        <table-setting
:style="{ float: 'right' }"
:table-size.sync="tableSize"
v-model="columns"
          :refresh-loading="loading"
@refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
ref="createForm"
:userList="userList"
:statusOptions="dict.type['sys_enable_disable']"
        @ok="getList" />
      <DevCan ref="DevCan"></DevCan>
      <!-- 批量导入 -->
      <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd>

      <!-- 数据展示 -->
      <a-table
:loading="loading"
:size="tableSize"
rowKey="id"
:columns="columns"
:data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
:pagination="false"
        :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137d:0:s']"
:checked="record.status === 1"
            @change="(checked) => handleStatusChange(record, checked)"
:loading="record.statusLoading"
            checked-children="启用"
un-checked-children="禁用" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <template  v-if="record.status==0">
              <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137d:0:d']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137r:0:r']" />
          <a @click="handleDelete(record)" v-hasPermi="['4d6dfa2fa128cdcc83fd033fdbb8e137r:0:r']"> 删除 </a>
          </template>
        
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
class="ant-table-pagination"
show-size-changer
show-quick-jumper
:current="queryParam.pageNum"
        :total="total"
:page-size="queryParam.pageSize"
:showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
@change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, editStatus } from '@/api/pressure/productCategory'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
// import Parameter from '../../pressure/parameter'
import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantFirmId: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '品类名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '品类简介',
          dataIndex: 'titleIntro',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: '排序号',
          dataIndex: 'sort',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
        },

        {
          title: '创建时间',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
 
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    //  点击启用禁用
    handleStatusChange(record, checked) {
      const newStatus = checked ? 1 : 0
      const actionText = checked ? '启用' : '禁用'

      this.$confirm({
        title: `确认${actionText}`,
        content: `确定要${actionText} "${record.name}" 品类吗？`,
        onOk: () => {
          record.statusLoading = true
          return editStatus({ id: record.id })
            .then(() => {
              record.status = newStatus
              this.$message.success(`${actionText}成功`)
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`)
            })
            .finally(() => {
              record.statusLoading = false
            })
        },
        onCancel: () => { },
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
  },
}
</script>
